<template>
  <div class="section section--full-page center">
    <div class="container max-width-mobile">
      <img
        v-if="imageUrl"
        class="image image--provider"
        :src="imageUrl"
        :alt="`app download jumbo image`"
        data-test-id="message-image"
      >

      <app-download-badges
        v-if="isMobileAppDownloadEnabled"
        class="spacing"
        :title="appDownloadTitle"
        :subtitle="appDownloadSubtitle"
      />
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'AppDownloadPage',

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),

      imageUrl() {
        return this.content.GiftClaimAppDownloadLandingPage?.metadata.imageUrl;
      },

      appDownloadTitle() {
        return this.content.GiftClaimAppDownloadLandingPage?.metadata.header;
      },

      appDownloadSubtitle() {
        return this.content.GiftClaimAppDownloadLandingPage?.metadata.content;
      },

      isMobileAppDownloadEnabled() {
        return this.merchant.features.aosUrl || this.merchant.features.iosUrl;
      }
    }
  };
</script>
